export const numDetect = 4

export const dataOperators = [
	{
		key: 'indosat_paket_internet',
		label: 'Indosat',
		icon: '/assets/images/operator/indosat.png',
		numbers: ['0814', '0815', '0816', '0855', '0856', '0857', '0858']
	},
	{
		key: 'telkomsel_paket_internet',
		label: 'Telkomsel',
		icon: '/assets/images/operator/telkomsel.png',
		numbers: ['0852', '0853', '0811', '0812', '0813', '0821', '0822', '0851']
	},
	{
		key: 'xl_paket_internet',
		label: 'XL Axiata',
		icon: '/assets/images/operator/xl-axiata.png',
		numbers: ['0817', '0818', '0819', '0859', '0877', '0878']
	},
	{
		key: 'axis_paket_internet',
		label: 'Axis',
		icon: '/assets/images/operator/axis.png',
		numbers: ['0838', '0831']
	},
	{
		key: 'tri_paket_internet',
		label: 'Tri (3)',
		icon: '/assets/images/operator/tri.png',
		numbers: ['0896', '0897', '0898', '0899']
	},
	{
		key: 'smartfren_paket_internet',
		label: 'Smartfren',
		icon: '/assets/images/operator/smartfren.png',
		numbers: ['0881', '0882', '0883', '0884']
	}	
]

export const operators = [
	{
		key: 'indosat',
		label: 'Indosat',
		icon: '/assets/images/operator/indosat.png',
		numbers: ['0814', '0815', '0816', '0855', '0856', '0857', '0858']
	},
	{
		key: 'telkomsel',
		label: 'Telkomsel',
		icon: '/assets/images/operator/telkomsel.png',
		numbers: ['0852', '0853', '0811', '0812', '0813', '0821', '0822', '0851']
	},
	{
		key: 'xl',
		label: 'XL Axiata',
		icon: '/assets/images/operator/xl-axiata.png',
		numbers: ['0817', '0818', '0819', '0859', '0877', '0878']
	},
	{
		key: 'axis',
		label: 'Axis',
		icon: '/assets/images/operator/axis.png',
		numbers: ['0838', '0831']
	},
	{
		key: 'three',
		label: 'Tri (3)',
		icon: '/assets/images/operator/tri.png',
		numbers: ['0896', '0897', '0898', '0899']
	},
	{
		key: 'smartfren',
		label: 'Smartfren',
		icon: '/assets/images/operator/smartfren.png',
		numbers: ['0881', '0882', '0883', '0884']
	}
]

// PRABAYAR
export let nominals = {
	pulsa: {
		nominals: [
			{
				id: 1,
				category_id: 1,
				label: '15.000',
				name: 'Telkomsel - 15.000',
				price: 15000
			},
			{
				id: 2,
				category_id: 1,
				label: '50.000',
				name: 'Telkomsel - 50.000',
				price: 50000
			}
		]
	},
	paketdata: {
		nominals: [
			{
				id: 1,
				category_id: 2,
				label: 'Paket Bicara Semua Operator 7 hari',
				price: 25000
			},
			{
				id: 2,
				category_id: 2,
				label: 'Internet OMG 75RB/30 Hari',
				price: 75000
			}
		]
	}
}

// PRODUCT PULSA
export let product = {
	bpjs: {
		kesehatan: [
			{
				id: 1,
				label: 'February ' + new Date().getFullYear(),
				name: 'BPJS Kesehatan - February ' + new Date().getFullYear(),
				price: 230021
			},
			{
				id: 2,
				label: 'Maret ' + new Date().getFullYear(),
				name: 'BPJS Kesehatan - Maret ' + new Date().getFullYear(),
				price: 330021
			},
			{
				id: 3,
				label: 'April ' + new Date().getFullYear(),
				name: 'BPJS Kesehatan - April ' + new Date().getFullYear(),
				price: 430021
			}
		]
	},
	roaming: [
		{
			id: 1,
			label: 'RoaMAX Internet Malaysia',
			name: 'RoaMAX Internet Malaysia',
			price: 150000
		},
		{
			id: 2,
			label: 'RoaMAX Internet Continent',
			name: 'RoaMAX Internet Continent',
			price: 150000
		},
		{
			id: 3,
			label: 'RoaMAX Internet Asia Australia',
			name: 'RoaMAX Internet Asia Australia',
			price: 150000
		}
	],
	token_pln: [
		{
			id: 1,
			label: '20.000',
			price: 21500,
			name: 'Token Listrik - 20.000'
		},
		{
			id: 2,
			label: '50.000',
			price: 51500,
			name: 'Token Listrik - 50.000'
		},
		{
			id: 3,
			label: '100.000',
			price: 101500,
			name: 'Token Listrik - 100.000'
		},
	],
	paketdata: [
		{
			id: 1,
			provider_id: 1,
			label: 'Data Hingga 12GB (Zona)',
			name: 'Data Hingga 12GB (Zona)',
			key: '',
			price: 102500
		},
		{
			id: 2,
			provider_id: 1,
			label: 'Internet OMG 30RB / 7 Hari',
			name: 'Internet OMG 30RB / 7 Hari',
			key: '',
			price: 30000
		},
		{
			id: 3,
			provider_id: 1,
			label: 'Internet OMG 75RB / 7 Hari',
			name: 'Internet OMG 75RB / 7 Hari',
			key: '',
			price: 75000
		},
		{
			id: 4,
			provider_id: 1,
			label: 'Internet OMG 150RB / 7 Hari',
			name: 'Internet OMG 150RB / 7 Hari',
			key: '',
			price: 150000
		}
	],
	pulsa: [
		{
			id: 1,
			provider_id: 1,
			label: '15.000',
			name: 'Telkomsel - 15.000',
			key: 15000,
			price: 16500
		},
		{
			id: 2,
			provider_id: 1,
			label: '25.000',
			name: 'Telkomsel - 25.000',
			key: 25000,
			price: 26500
		},
		{
			id: 3,
			provider_id: 1,
			label: '30.000',
			name: 'Telkomsel - 30.000',
			key: 30000,
			price: 31500
		},
		{
			id: 4,
			provider_id: 1,
			label: '40.000',
			name: 'Telkomsel - 40.000',
			key: 40000,
			price: 41500
		},
		{
			id: 5,
			provider_id: 1,
			label: '50.000',
			name: 'Telkomsel - 50.000',
			key: 50000,
			price: 51500
		}
	]
}